import { motion } from "framer-motion";
import { Database, Smartphone, Layout, MonitorPlay } from "lucide-react";
import { useNavigate } from "react-router-dom";

const solutionTabs = [
  {
    title: "Tất cả",
    description: "Thư viện nền tảng cho nhiều mô hình triển khai",
    icon: Layout,
  },
  {
    title: "Website Doanh nghiệp & Thương mại điện tử",
    description: "Khung web chuẩn UX/UI, SEO và chuyển đổi",
    icon: MonitorPlay,
  },
  {
    title: "Dashboard CRM / ERP / POS",
    description: "Giao diện quản trị cho dữ liệu và vận hành",
    icon: Database,
  },
  {
    title: "Mobile UI UX",
    description: "Thiết kế ứng dụng di động cho nhiều tác vụ",
    icon: Smartphone,
  },
];

const SectionExplore = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-white pt-8">
      <div className="container mx-auto px-4 sm:px-6">
        <motion.div
          className="overflow-hidden rounded-[28px] border border-red-100 bg-[linear-gradient(135deg,#2f0a0a_0%,#571313_48%,#831919_100%)] shadow-[0_26px_70px_rgba(127,29,29,0.18)]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="relative overflow-hidden px-5 py-8 sm:px-7 sm:py-10 lg:px-10 lg:py-12">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.16),transparent_36%)]" />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.02)_0%,rgba(0,0,0,0.08)_100%)]" />

            <div className="relative z-10 grid gap-8 lg:grid-cols-[1.12fr_0.88fr] lg:items-end">
              <div className="max-w-[760px]">
                <span className="inline-flex items-center rounded-full border border-red-200/30 bg-white/8 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-white">
                  Thư viện giải pháp số
                </span>
                <h1 className="mt-5 text-[28px] font-semibold leading-[1.16] text-white sm:text-[34px] lg:text-[42px]">
                  Thư Viện Nền Tảng Số & Giao Diện Cấu Trúc Cao Cấp
                </h1>
                <p className="mt-4 max-w-[720px] text-[15px] leading-8 text-white sm:text-[16px]">
                  Hệ thống mẫu giao diện chuẩn UX/UI, tích hợp sẵn tư vấn cấu trúc dữ liệu và tối
                  ưu chuyển đổi Marketing cho đa dạng lĩnh vực kinh doanh.
                </p>

                <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                  <button
                    onClick={() => navigate("/store/website")}
                    className="button-primary h-[44px] min-w-[190px] border-none bg-white text-red-700 shadow-[0_14px_30px_rgba(0,0,0,0.18)] hover:!bg-red-50 hover:!text-red-800 flex items-center justify-center"
                  >
                    Khám phá thư viện
                  </button>
                  <button
                    onClick={() => navigate("/contact")}
                    className="button-secondary h-[44px] min-w-[210px] border border-white/30 bg-transparent text-white hover:!border-red-200 hover:!bg-white/10 hover:!text-white flex items-center justify-center"
                  >
                    Nhận tư vấn cấu trúc giải pháp
                  </button>
                </div>
              </div>

              <div className="grid gap-3 sm:grid-cols-2">
                {solutionTabs.map(({ title, description, icon: Icon }) => (
                  <div
                    key={title}
                    className="rounded-[20px] border border-white/20 bg-white/8 p-4 backdrop-blur-sm"
                  >
                    <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-white/12 text-white">
                      <Icon size={22}  />
                    </div>
                    <h3 className="text-[15px] font-semibold leading-6 text-white drop-shadow-[0_1px_1px_rgba(0,0,0,0.18)]">
                      {title}
                    </h3>
                    <p className="mt-2 text-[13px] leading-6 text-white">
                      {description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SectionExplore;
